import { Link } from "react-router-dom";

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<div className="footer-section footer-links">
					<a
						href="https://discord.gg/W54Zhj2PD3"
						target="_blank"
						rel="noreferrer"
						className="footer-link"
					>
						Discord
					</a>
					<span className="footer-separator">•</span>
					<a
						className="footer-link"
						href="https://qr.mobilepay.dk/box/9229be2b-bcf7-4f26-acfc-e43ed97e7a5d/pay-in"
						target="_blank"
						rel="noreferrer"
					>
						MobilePay
					</a>
					<span className="footer-separator">•</span>
					<Link to="/privacy" className="footer-link">
						Privacy
					</Link>
				</div>

				<div className="footer-section footer-center">
					<span className="footer-description">
						PowerStats • CS2 statistik for PowerLigaen
					</span>
				</div>

				<div className="footer-section footer-credits">
					<span className="footer-credit">
						Developed by{" "}
						<a
							href="https://twitter.com/realxGuys"
							target="_blank"
							rel="noreferrer"
							className="footer-link"
						>
							TigerX
						</a>
						{" & "}
						<a
							href="https://twitter.com/RealSoerensen"
							target="_blank"
							rel="noreferrer"
							className="footer-link"
						>
							Soerensen
						</a>
						{" • Theme by Roefus"}
					</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
